import PermissionCheck from "./mixins/PermissionCheck";

const GlobalMixins = {
  install(Vue) {
    Vue.mixin(PermissionCheck);
  }
};

export default GlobalMixins;

// export default {
//   methods: {
//       currentUser() {
//           return window.currentUser;
//       },
//   },
// };

{
  /* <script>
  export default {
    methods: {
      $can(permissionName) {
        return Permissions.indexOf(permissionName) !== -1;
      },
    },
  };
</script> */
}
